
/**
 * @deprecated A gestão de permissões foi unificada em /settings?tab=access
 * (Acessos & Permissões → Catálogo de Permissões).
 */
export default function PermissionsRedirect() {
    return null;
}

